import { navigate } from "@reach/router";
import { useEffect } from "react";

/**
 * redirects from old urls:
 * 	account/431/request-for-quote/489/submission/130/returnable-schedules
 *  (130 is COMPANYID)
 *
 * to:
 * 	a provider, that will get the submission id by RFx and COmpany Id and then re-route to the correct Url
 *
 * @param param0
 * @returns
 */
const DeprecatedRfxSubmissionRedirect: React.FC<{
	companyId?: number;
	currentTab?: string;
	isSupplier?: boolean;
	path: string;
	rfxId?: number;
	submissionCompanyId?: number;
}> = ({
	companyId,
	currentTab,
	isSupplier = false,
	rfxId,
	submissionCompanyId,
	path,
}) => {
	useEffect(() => {
		if (!companyId || !rfxId || (!isSupplier && !submissionCompanyId)) {
			return;
		}

		let redirectPath = `/account/${companyId}/rfx/${rfxId}/getsubmission/${isSupplier ? companyId : submissionCompanyId}/`;

		if (currentTab) {
			redirectPath += `${currentTab}/`;
		}

		navigate(redirectPath, {
			replace: true,
		});
	}, [companyId, currentTab, isSupplier, rfxId, submissionCompanyId]);

	return null;
};

export default DeprecatedRfxSubmissionRedirect;
